import React from "react";
import styles from "./ArcadeFond.module.css";
import {BLOCS, EXTRATERRESTRES, graine, rectangles} from "./sprites";
import {PALETTES, REGLAGES} from "./reglages";
import {resoudre} from "../reglages";

/**
 * Fonds du thème Arcade : trois ambiances de salle d'arcade, dessinées en SVG et CSS purs (dessins et code originaux, aucun
 * personnage ni logo d'un jeu existant). Un seul composant, trois variantes (`variante`) :
 *   envahisseurs : petits extraterrestres génériques qui défilent en rangs sur un ciel d'étoiles ;
 *   blocs        : pièces de blocs colorées qui tombent doucement ;
 *   credits      : « INSERT COIN » et score qui clignotent sur un écran à lignes de balayage.
 * Tout bouge par `transform` ou `opacity` ; les positions sont tirées une fois avec une graine fixe.
 */
const SPRITES = EXTRATERRESTRES.map(rectangles);

function Alien({dessin, couleur}) {
    return (
        <svg viewBox="0 0 10 8" shapeRendering="crispEdges" className={styles.sprite} fill={couleur}>
            {SPRITES[dessin].map((r, i) => <rect key={i} x={r.x} y={r.y} width={r.l} height={1}/>)}
        </svg>
    );
}

function Envahisseurs({nombre, palette}) {
    const hasard = graine(11);
    return Array.from({length: nombre}, (_, i) => (
        <div key={i} className={styles.rang} style={{top: `${8 + hasard() * 64}%`, animationDelay: `${-hasard() * 40}s`, animationDuration: `${34 + hasard() * 18}s`}}>
            <div className={styles.flotte} style={{animationDelay: `${-hasard() * 2}s`}}>
                <Alien dessin={i % SPRITES.length} couleur={palette.vives[i % palette.vives.length]}/>
            </div>
        </div>
    ));
}

function Blocs({nombre, palette}) {
    const hasard = graine(23);
    return Array.from({length: nombre}, (_, i) => {
        const forme = BLOCS[Math.floor(hasard() * BLOCS.length)];
        return (
            <div key={i} className={styles.chute} style={{left: `${hasard() * 92}%`, animationDelay: `${-hasard() * 30}s`, animationDuration: `${22 + hasard() * 14}s`}}>
                <svg viewBox="0 0 4 2" className={styles.bloc} shapeRendering="crispEdges" fill={palette.vives[i % palette.vives.length]}>
                    {forme.map(([x, y], j) => <rect key={j} x={x} y={y} width={0.9} height={0.9}/>)}
                </svg>
            </div>
        );
    });
}

const MOTS = ["INSERT COIN", "PRESS START", "HIGH SCORE 009900", "GAME OVER ?", "PLAYER 1 READY", "x2 BONUS", "1UP", "LEVEL 99"];

function Credits({nombre, palette}) {
    const hasard = graine(37);
    return Array.from({length: Math.min(nombre, MOTS.length * 2)}, (_, i) => (
        <span key={i} className={styles.mot} style={{left: `${hasard() * 80}%`, top: `${6 + hasard() * 80}%`, color: palette.vives[i % palette.vives.length],
            animationDelay: `${-hasard() * 6}s`, animationDuration: `${3 + hasard() * 3}s`}}>{MOTS[i % MOTS.length]}</span>
    ));
}

const VARIANTES = {envahisseurs: Envahisseurs, blocs: Blocs, credits: Credits};

export default function ArcadeFond({variante = "envahisseurs", reglages}) {
    const r = resoudre(REGLAGES, reglages);
    const palette = PALETTES[r.couleurs] || PALETTES.neon;
    const Variante = VARIANTES[variante] || Envahisseurs;
    return (
        <div className={styles.scene} aria-hidden="true"
             style={{"--fond": palette.fond, "--fond2": palette.fond2, "--vitesse": 1 / r.vitesse, "--vive": palette.vives[0]}}>
            <div className={styles.etoiles}/>
            <div className={styles.contenu}><Variante nombre={r.nombre} palette={palette}/></div>
            <div className={styles.balayage}/>
        </div>
    );
}

export const fondArcade = variante => function FondArcade(props) {
    return <ArcadeFond variante={variante} {...props}/>;
};
